import type { SurveyQuestion } from '../../fetchSurvey/types';
import type { LogicContext } from '../types';
import { getVisibleQuestions } from './questionVisibility';

export function shouldIncludePageInPath(
  questions: SurveyQuestion[],
  context: LogicContext
): boolean {
  if (questions.length === 0) {
    return false;
  }

  return getVisibleQuestions(questions, context).length > 0;
}

export function isPageOnActivePath(
  questions: SurveyQuestion[],
  context: LogicContext
): boolean {
  return shouldIncludePageInPath(questions, context);
}
